import { ReactComponent as Vector } from "../../assets/images/svg/Vector.svg";
import Header from "../../components/Header/Header";
import { useEffect } from "react";
import { getDecodedToken } from "../../utils/functions";
import PageHeading from "../../components/PageHeading/PageHeading";
import PageTitle from "../../components/PageTitle/PageTitle";
import ArrowLink from "../../components/ArrowButton/ArrowLink";

const Welcome = () => {
  useEffect(() => {
    const htmlEl = document.getElementById("html");
    htmlEl.style.overflowY = "auto";
  }, []);

  return (
    <>
      <PageTitle title={"Welcome"} />
      <Header isLogoNavigationEnabled={false} />
      <div className="container">
        <div className="welcome_page">
          <div className="welcome_head">
            <Vector role="img" aria-label="Welcome" />
          </div>
          <div className="welcome_letter">
            <PageHeading
              headingClass="head_name"
              headingText={`Dear ${getDecodedToken()?.full_name + "," || ""}`}
            />
            <p>
              I welcome you to the{" "}
              <span className="blueTextColor fontWeight700">
                Nuvama Private
              </span>{" "}
              family, where our endeavour is to deliver solutions tailored to
              your financial needs.
            </p>
            <p>
              We will constantly strive to provide you with a one stop solution
              for your Individual, family and business needs conjoined with
              best-in-class client experience.
            </p>
            <p>
              With our{" "}
              <span className="blueTextColor fontWeight700">
                Nuvama Private website
              </span>
              , you can now track your wealth as well as access advanced
              analytics to gauge your portfolio's performance at your
              fingertips. This innovative and first-of-its-kind site provides
              you with an outstanding user experience where you can view your
              portfolio data and benefit from simpler financial reporting.
            </p>
            <p>
              I hope you enjoy navigating through the site. Stay tuned, as we
              unveil more valuable features for you to explore!
            </p>

            <p>Best Wishes,</p>
          </div>
          <div className="president_foolter">
            <div>
              <p className="president-name">Alok Saigal</p>
              <p className="Designation">President & Head,</p>
              <p className="company blueTextColor fontWeight700">
                Nuvama Private
              </p>
            </div>
          </div>
          <div className="continue">
            <ArrowLink
              type="next"
              label="Continue"
              navigateTo="/aboutus"
              ariaLabel={"Continue to About Us Page"}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Welcome;
